export const GET_BUDGETS_REQUEST = 'GET_BUDGETS_REQUEST';
export const GET_BUDGETS_SUCCESS = 'GET_BUDGETS_SUCCESS';
export const GET_BUDGETS_FAILURE = 'GET_BUDGETS_FAILURE';
export const SAVE_BUDGETS_REQUEST = 'SAVE_BUDGETS_REQUEST';
export const SAVE_BUDGETS_SUCCESS = 'SAVE_BUDGETS_SUCCESS';
export const SAVE_BUDGETS_FAILURE = 'SAVE_BUDGETS_FAILURE';
export const SET_BUDGET = 'SET_BUDGET';
